import React, { useContext, useEffect, useState, Suspense } from 'react';
import PropTypes from 'prop-types';
import { singleTopicPropTypes, articleContentProps } from '../../defaultProps';
import Layout from '../../../components/Layout/LayoutV2/Layout';
import { PageContext } from '../../../contexts/ContextCreator';
import { Provider as CommunityContextProvider } from '../../../contexts/CommunityContext';
import './ArticlePage.scss';
import { CommunityContentLandingPage } from '../../../components/Community/SingleContent/CommunityContentDisplayV2/CommunityContentLandingPage';
import { CommunityContentProvider } from '../../../components/Community/SingleContent/CommunityContentDisplayV2/CommunityContentContext';

const GoogleOneTap = React.lazy(() =>
    import('../../../components/Login/GoogleOneTap/GoogleOneTap')
);

const ArticlePage = (props) => {
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        setIsMounted(true);
    }, []);

    const { content, recentContent } = props;
    const { isLoggedIn, pageProps } = useContext(PageContext);

    const showGoogleoneTapLogin = () => {
        return (
            typeof window !== 'undefined' &&
            window?.document?.referrer.includes('google') &&
            !isLoggedIn()
        );
    };

    return (
        <CommunityContextProvider
            singleAttributionContentHash={props.content.hash}
            attributionMode="single"
            content={[content]}
            topics={props?.topics}
        >
            <div className="article-page">
                {isMounted && showGoogleoneTapLogin() && (
                    <Suspense fallback={null}>
                        <GoogleOneTap gclientId={pageProps.googleClientId} />
                    </Suspense>
                )}
                <Layout
                    {...props}
                    topBannerOnlyShownList={['admin-onboard']}
                    className={props.group?.groupUrl ? 'groups-layout' : ''}
                >
                    <CommunityContentProvider
                        content={content}
                        recentContent={recentContent}
                    >
                        <CommunityContentLandingPage />
                    </CommunityContentProvider>
                </Layout>
            </div>
            )
        </CommunityContextProvider>
    );
};

ArticlePage.propTypes = {
    PAGE_PROPS: PropTypes.shape({ featureFlags: PropTypes.shape({}) }),
    adminOnboardingProps: PropTypes.shape({}),
    /**
     * Content props
     */
    recentContent: PropTypes.arrayOf(singleTopicPropTypes),
    content: articleContentProps.isRequired,
    ancestorHash: PropTypes.string,
    /**
     * This is used in Three Column Grid Layout
     */
    topics: PropTypes.arrayOf(singleTopicPropTypes).isRequired,
    /**
     * Boolean as to hide reaction bar for the Editorial/Podcast Content
     */
    // This is a known es-lint bug where if it's a prop that's just passed, it's not considered used...
    /* eslint-disable-next-line  react/no-unused-prop-types */
    hideReactionBar: PropTypes.bool,
    group: PropTypes.shape({
        groupUrl: PropTypes.string,
    }),
    location: PropTypes.string,
    userRelation: PropTypes.shape({}),
};

ArticlePage.defaultProps = {
    PAGE_PROPS: {},
    recentContent: null,
    adminOnboardingProps: {},
    hideReactionBar: false,
    group: null,
    location: null,
    userRelation: null,
    ancestorHash: null,
};

export default ArticlePage;
